import contributionRates from './contributionRates.json';
export var contributionRatesByPostcode = contributionRates;
export var GENERAL_DISCOUNT = 0.04;
export var SECURITY_DEVICE_DISCOUNT = 0.05;
export var PREMIUM_TAX = 1.1615;
export var ADD_ON_TAX = 1.19;
export var PREMIUM_FACTOR_VALUE = 1000;
export var GLASS_PRICE_FACTOR_VALUE = 0.309291396426208;
export var GLASS_PRICE_MIN = 7.44;
export var BIKE_PRICE_MIN_FACTOR_VALUE = 0.01;
export var BIKE_PRICE_FACTOR_VALUE = 10;
export var RECOMMENDED_INSURED_SUM_FACTOR_VALUE = 650;
